import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Field,
  FieldArray,
} from 'formik';
import { TextAreaFormField, InputFormField } from '@playbookux/playbook-web-core';

import {
  AnswersContainer,
  InputAnswerContainer,
  ContainerAddItem,
  ContainerAddQuestion,
  AddQuestion,
} from './styles';

import ErrorMessage from '../error';
import RemoveButton from './remove-button';

const AddQuestionComponent = (props) => {
  const {
    index,
    errors,
    touched,
    question,
    isEdit,
    taskIndex,
    testType,
  } = props;

  const showOtherButton = useMemo(() => (
    !_.find(question.questionOptions, { optionType: 'other' })
  ), [question.questionOptions]);

  const disabled = isEdit || question.questionOptions.length <= 2;

  const handleRemove = (arrayHelpers, indexOption) => {
    arrayHelpers.remove(indexOption);
  };

  const handleAddOtherAnswer = (arrayHelper) => {
    const otherAnswer = { label: 'Other', optionType: 'other' };
    return arrayHelper.push(otherAnswer);
  };

  const handleAddAnswer = (arrayHelper, arr) => {
    const newAnswer = { label: '', optionType: 'answer' };
    const lastOption = _.last(arr);

    // insert before if last item is Other type
    if (lastOption.optionType === 'other') return arrayHelper.insert(arr.length - 1, newAnswer);

    return arrayHelper.push(newAnswer);
  };

  let label = '';
  let nameField = '';
  let nameFildArray = '';

  if (testType === 'survey') {
    nameField = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.label`;
    nameFildArray = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.questionOptions`;
  } else {
    nameField = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}]` : ''}tasks.${index}.label`;
    nameFildArray = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}]` : ''}tasks.${index}.questionOptions`;
  }

  return (
    <>
      <Field
        placeholder="Start typing your question"
        minWidth="100%"
        component={TextAreaFormField}
        name={nameField}
      />
      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
      />
      <FieldArray
        name={nameFildArray}
        render={(arrayHelpers) => (
          <>
            {question.questionOptions.map((option, indexOption) => {
              if (testType === 'survey') {
                label = `${(taskIndex || taskIndex === 0)
                  ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.questionOptions.${indexOption}.label`;
              } else {
                label = `${(taskIndex || taskIndex === 0)
                  ? `tasks[${taskIndex}]` : ''}tasks.${index}.questionOptions.${indexOption}.label`;
              }
              return (
                <AnswersContainer>
                  <InputAnswerContainer>
                    <Field
                      name={label}
                      placeholder="Type your answer here"
                      component={InputFormField}
                      widthsize="90%"
                      audience
                    />
                  </InputAnswerContainer>

                  <RemoveButton
                    onClick={() => handleRemove(arrayHelpers, indexOption)}
                    disabled={disabled}
                    isEdit={isEdit}
                  />
                </AnswersContainer>
              );
            })}
            <ContainerAddQuestion>
              {!isEdit && (
                <ContainerAddItem>
                  <AddQuestion onClick={() => handleAddAnswer(arrayHelpers, question.questionOptions)}>
                    + Answer
                  </AddQuestion>
                  {showOtherButton && (
                    <AddQuestion
                      onClick={() => handleAddOtherAnswer(arrayHelpers)}
                    >
                      + &#39;Other&#39; as an answer choice
                    </AddQuestion>
                  )}
                </ContainerAddItem>
              )}
            </ContainerAddQuestion>
          </>
        )}
      />
    </>
  );
};

AddQuestionComponent.propTypes = {
  question: PropTypes.shape({
    questionOptions: PropTypes.array,
  }).isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape({}).isRequired,
  touched: PropTypes.shape({}).isRequired,
  isEdit: PropTypes.bool.isRequired,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
};

AddQuestionComponent.defaultProps = {
  taskIndex: null,
};

export default AddQuestionComponent;
